/** Digits only, capped when a max length is given. */
export function digitsOnly(value: string, maxLength?: number): string {
  const digits = value.replace(/\D/g, '');
  return maxLength == null ? digits : digits.slice(0, maxLength);
}

/** US ZIP or ZIP+4. Letters are dropped. A hyphen is added after five digits. */
export function formatUsZip(value: string): string {
  const digits = digitsOnly(value, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

export function usZipError(value: string): string {
  const zip = value.trim();
  if (!zip) return '';
  return /^\d{5}(-\d{4})?$/.test(zip) ? '' : 'Enter a 5-digit ZIP code.';
}
